// The server persists this at first sale opening. Never infer it from a moving
// deadline, first-ball time or the browser clock. Fallback supports old receipts.
export function drawNumber(draw:{drawId:string;drawNumber?:string|null}):string {
 return draw.drawNumber||draw.drawId.slice(0,6).toUpperCase();
}
